import React, { useContext, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import AppContext from "../../../../appContext";
import InnerPageStructure from "../../../../shared/components/generic/inner-page-structure/inner-page-structure";
import ModuleTabs from "../../../../shared/components/generic/module-tabs/module-tabs";
import PageStateMessage from "../../../../shared/components/generic/page-state-message/page-state-message";
import { TokenUtils } from "../../../../shared/utils/TokenUtils";
import { adminTabs } from "../../config/admin/admin-tabs-config";
import { hasAdminPermission } from "../../utils/admin-utils";
import Segmentacao from "../segmentation/segmentacao";
import ObjetivosVarilux from "../varilux-goals/objetivos-varilux";
import ObjetivosNetSales from "../net-sales/net-sales";
import PenalidadePorInadimplencia from "../late-payment-penalty/penalidade-por-inadimplencia";
import Reajuste from "../adjustment/reajuste";
import ParametrosPactoRebates from "../pacto-rebates-params/parametros-pacto-rebates";
import CadastroFeriados from "../holiday-management/cadastro-feriados";
import "./admin.css";

const Admin = () => {
	const context = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();

	const [hasModuleAccess, setHasModuleAccess] = useState(null);

	const searchParams = new URLSearchParams(location.search);
	const activeTab = searchParams.get("tab");

	const availableTabs = useMemo(() => {
		return adminTabs.filter(tab => {
			return hasAdminPermission(context.userSession, tab.permission);
		});
	}, [context.userSession]);

	const activeTabIsAllowed = availableTabs.some(tab => tab.key === activeTab);
	const fallbackTab = availableTabs[0]?.key || "";
	const currentTab = activeTabIsAllowed ? activeTab : fallbackTab;

	useEffect(() => {
		setHasModuleAccess(TokenUtils.hasModuloPactoAdminSimulador());
	}, []);

	useEffect(() => {
		if (!context.userSession || !fallbackTab || !hasModuleAccess) {
			return;
		}

		if (!activeTab || !activeTabIsAllowed) {
			history.replace({
				pathname: "/pacto-admin",
				search: `?tab=${fallbackTab}`
			});
		}
	}, [
		context.userSession,
		activeTab,
		activeTabIsAllowed,
		fallbackTab,
		hasModuleAccess,
		history
	]);

	const handleTabChange = tabKey => {
		history.push({
			pathname: "/pacto-admin",
			search: `?tab=${tabKey}`
		});
	};

	const components = {
		segmentation: Segmentacao,
		variluxGoals: ObjetivosVarilux,
		netSalesGoals: ObjetivosNetSales,
		penalties: PenalidadePorInadimplencia,
		adjustment: Reajuste,
		pactoRebatesParameters: ParametrosPactoRebates,
		holidayManagement: CadastroFeriados
	};

	const ActiveComponent = components[currentTab];

	const innerPageElements = {
		backLabel: [{ label: "Administração do Pacto Rebates" }],
		title: "Admin Pacto Rebates",
	};

	if (!context.userSession || hasModuleAccess === null) {
		return (
			<PageStateMessage title="Carregando..." />
		);
	}

	if (!hasModuleAccess || availableTabs.length === 0) {
		return (
			<PageStateMessage
				title="Acesso Negado"
				description="Você não possui permissão para acessar os módulos administrativos do Pacto Rebates."
			/>
		);
	}

	return (
		<InnerPageStructure innerPageElements={innerPageElements}>
			<div className="admin">
				<ModuleTabs
					tabs={availableTabs}
					activeKey={currentTab}
					onChange={handleTabChange}
				/>

				{ActiveComponent && (
					<ActiveComponent />
				)}
			</div>
		</InnerPageStructure>
	);
};

export default Admin;